var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from "react-router-dom";
import * as optionTypeFactory from '../../../classes/definitions/optionType/optionType';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import optionTypeSchema from "../../../schemas/optionTypeSchema";
import Input from '../../UI/Input/Input';
var OptionTypeForm = /** @class */ (function (_super) {
    __extends(OptionTypeForm, _super);
    function OptionTypeForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.messages = null;
        _this.state = {
            formConfig: _.cloneDeep(optionTypeSchema),
            formIsValid: false,
            discardPopupVisble: false
        };
        _this.getDisplayTypes = function () {
            _this.api.getDisplayTypes()
                .then(function (response) {
                _this.setDisplayTypesDropdown(_.get(response, 'data.display_types', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка с извличане на тип';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDisplayTypesDropdown = function (types) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig['display_type']);
            updatedFormElement.elementConfig.options = [];
            for (var key in types) {
                if (Object.prototype.hasOwnProperty.call(types, key)) {
                    // const type = types[key];
                    updatedFormElement.elementConfig.options.push({
                        label: NotosService.formatDisplayTypes(key),
                        value: key
                    });
                }
            }
            _this.setState({ formConfig: updatedFormConfig });
            _this.editId = _.get(_this.props, 'match.params.id', '-1');
            if (_this.editId !== '-1') {
                _this.props.isEdit(true);
                _this.getOptionType(_this.editId);
            }
        };
        _this.getOptionType = function (id) {
            _this.api.getOptionType(id)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на Option Type';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var optionType = optionTypeFactory.createOptionType(_.get(data, 'attributes', {}));
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'bg_name.value', optionType.BgName);
            _.set(updatedFormConfig, 'bg_name.touched', true);
            _.set(updatedFormConfig, 'bg_name.valid', true);
            _.set(updatedFormConfig, 'en_name.value', optionType.EnName);
            _.set(updatedFormConfig, 'en_name.touched', true);
            _.set(updatedFormConfig, 'en_name.valid', true);
            _.set(updatedFormConfig, 'display_type.value', optionType.DisplayType);
            _.set(updatedFormConfig, 'display_type.touched', true);
            _.set(updatedFormConfig, 'display_type.valid', true);
            _this.setState({ formConfig: updatedFormConfig, formIsValid: NotosService.checkFormValidity(updatedFormConfig) });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            updatedFormElement.value = event.target.value;
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({ formConfig: updatedFormConfig, formIsValid: NotosService.checkFormValidity(updatedFormConfig) });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var submittedOptionType = optionTypeFactory.createOptionType({
                bg_name: _.get(formData, 'bg_name.value', ''),
                en_name: _.get(formData, 'en_name.value', ''),
                display_type: _.get(formData, 'display_type.value', ''),
            });
            var actionMethod = _this.editId === '-1' ? _this.api.createOptionType : _this.api.updateOptionType;
            actionMethod(submittedOptionType, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                // goes to the edit page if a new option type is created, on update goes to the list page  
                _this.editId === '-1' ?
                    _this.toEditOptionTypePage(_.get(response, 'data.id', -1)) : _this.toOptionTypesPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на Option Type';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toOptionTypesPage = function () {
            _this.props.history.push(AppRoutes.optionTypes.path);
        };
        _this.toEditOptionTypePage = function (id) {
            _this.props.history.push(AppRoutes.editOptionType.path.replace(':id', id));
        };
        return _this;
    }
    OptionTypeForm.prototype.componentDidMount = function () {
        this.getDisplayTypes();
    };
    OptionTypeForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key
                });
            }
        }
        // Building form inputs
        var form = (formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) { return _this.eventHandlers(event, formElement.id, 'onChange'); }, blur: function (event) { return _this.eventHandlers(event, formElement.id, 'onBlur'); } }));
        }));
        var actionBtns = React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toOptionTypesPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK"));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
            form,
            actionBtns));
    };
    return OptionTypeForm;
}(React.Component));
// @ts-ignore
export default withRouter(OptionTypeForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/OptionTypes/OptionTypeForm/OptionTypeForm.tsx
// module id = 375
// module chunks = 0